module.exports = __webpack_public_path__ + "static/media/ic-arrow-right-white.82ad1b0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-right-white.svg
// module id = 595
// module chunks = 14